//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Positioning.js";
import "../no/NXObject.js";
import "../no/ugmath.js";
let d=[[],[[["persistent"],"CreateConstraint",{R_:{constraint:"Positioning.Constraint"}},1,0],[[],"CreateConstraint1",{R_:{constraint:"Positioning.Constraint"}},0,0],[[],"EstablishNetwork",{R_:{network:"Positioning.Network"}},0,0],[[],"ClearNetwork",{},0,0],[[],"DeleteNonPersistentConstraints",{},0,0]],[["Constraints","Positioning.ConstraintCollection",0]]];
SPLM.Positioning.Positioner = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Positioning.Positioner";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;